export default __webpack_public_path__ + "static/media/UzomaEdeonwe.c5e656a1.jpg";